export default "__VITE_ASSET__C5Rhp_2f__"